import React, { useState } from 'react';
import { useAuth } from './hooks/useAuth';
import styled from 'styled-components';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Alert from '@material-ui/lab/Alert';
import { useNavigate, useLocation } from 'react-router-dom';

const LargeHeader = styled.h1`
  font-size: calc(1px + 7vmin);
`;

const LoginDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 480px;
  background-color: #fff;
`;

const ErrorDiv = styled.div`
  margin-top: 2rem;
`;

export const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const redirectPath = location.state;
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isErrorVisible, setIsErrorVisible] = useState('');
  const handleUsernameChange = (e) => {
    setUsername(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = await login(username.trim(), password.trim());
    if (!token) {
      setIsErrorVisible(true);
      setTimeout(() => setIsErrorVisible(false), 5000);
      return;
    }
    // Redirect to history route
    if (redirectPath && redirectPath !== 'login') {
      navigate(redirectPath);
    } else {
      navigate('/');
    }
  };

  return (
    <LoginDiv>
      <LargeHeader>Smartcleaning App</LargeHeader>
      <h1>Please Log In</h1>
      <Box
        component="form"
        style={{
          display: 'flex',
          flexDirection: 'column',
          minWidth: '20rem',
          gap: '2rem',
          marginTop: '2rem',
        }}
      >
        <TextField
          required
          id="username"
          label="Username"
          variant="outlined"
          value={username}
          onChange={handleUsernameChange}
        />
        <TextField
          required
          id="outlined-password-input"
          label="Password"
          type="password"
          autoComplete="current-password"
          variant="outlined"
          value={password}
          onChange={handlePasswordChange}
        />
        <Button variant="contained" color="primary" onClick={handleSubmit}>
          Login
        </Button>
      </Box>
      {isErrorVisible && (
        <ErrorDiv>
          <Alert severity="error" onClose={() => setIsErrorVisible(false)}>
            Wrong username or password!
          </Alert>
        </ErrorDiv>
      )}
    </LoginDiv>
  );
};
